import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../../assets/batteryFrame/empty.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4f2aa09e")

_pushScopeId("data-v-4f2aa09e")
const _hoisted_1 = {
  class: "toc_ui__batteryHealthy_main",
  id: "batteryHealthy"
}
const _hoisted_2 = { class: "toc_ui__batteryHealthy_body" }
const _hoisted_3 = { class: "toc_ui__batteryHealthy_body_cont" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_main" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "Battery Health Inspection")
], -1)
const _hoisted_5 = { class: "batteryHealthyCircle" }
const _hoisted_6 = { class: "circleitem circle1" }
const _hoisted_7 = { class: "circleCont" }
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("Battery"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Health")
], -1)
const _hoisted_11 = { class: "sign" }
const _hoisted_12 = { class: "circleitem circle2" }
const _hoisted_13 = { class: "circleCont" }
const _hoisted_14 = { class: "number" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "label" }, [
  /*#__PURE__*/_createTextVNode("Estimated"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Range")
], -1)
const _hoisted_17 = { class: "batteryHealthyNum" }
const _hoisted_18 = { class: "batteryHealthyNumItem times" }
const _hoisted_19 = { class: "batteryHealthyNumItem_num" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyNumItem_label" }, "Charge Cycle Count", -1)
const _hoisted_22 = { class: "batteryHealthyNumItem del" }
const _hoisted_23 = { class: "batteryHealthyNumItem_num" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "batteryHealthyNumItem_label" }, "Average Degradation Rate", -1)
const _hoisted_26 = { class: "batteryHealthyRadar" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "empty"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("p", null, "暂无数据", -1)
const _hoisted_31 = { class: "batteryHealthyTable" }
const _hoisted_32 = { class: "rowLeft" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "rowTitle" }, "Cell Undervoltage", -1)
const _hoisted_34 = { class: "rowSubLine" }
const _hoisted_35 = { class: "subLabelsRow" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Measured Value:", -1)
const _hoisted_37 = { class: "subLabel" }
const _hoisted_38 = { class: "subValsRow" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Warning Threshold:", -1)
const _hoisted_40 = { class: "subLabel" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("u")
const _hoisted_43 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_44 = { class: "rowRight" }
const _hoisted_45 = { class: "rowLeft" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "rowTitle" }, "Cell Overvoltage", -1)
const _hoisted_47 = { class: "rowSubLine" }
const _hoisted_48 = { class: "subLabelsRow" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Measured Value:", -1)
const _hoisted_50 = { class: "subLabel" }
const _hoisted_51 = { class: "subValsRow" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Warning Threshold:", -1)
const _hoisted_53 = { class: "subLabel" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("u")
const _hoisted_56 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_57 = { class: "rowRight" }
const _hoisted_58 = { class: "rowLeft" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "rowTitle" }, "Voltage Difference", -1)
const _hoisted_60 = { class: "rowSubLine" }
const _hoisted_61 = { class: "subLabelsRow" }
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Measured Value:", -1)
const _hoisted_63 = { class: "subLabel" }
const _hoisted_64 = { class: "subValsRow" }
const _hoisted_65 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Warning Threshold:", -1)
const _hoisted_66 = { class: "subLabel" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("U")
const _hoisted_69 = /*#__PURE__*/_createVNode("sub", null, "max", -1)
const _hoisted_70 = /*#__PURE__*/_createTextVNode("-U")
const _hoisted_71 = /*#__PURE__*/_createVNode("sub", null, "min", -1)
const _hoisted_72 = { class: "rowRight" }
const _hoisted_73 = { class: "rowLeft" }
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { class: "rowTitle" }, "Battery Overtemperature", -1)
const _hoisted_75 = { class: "rowSubLine" }
const _hoisted_76 = { class: "subLabelsRow" }
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Measured Value:", -1)
const _hoisted_78 = { class: "subLabel" }
const _hoisted_79 = { class: "subValsRow" }
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Warning Threshold:", -1)
const _hoisted_81 = { class: "subLabel" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("T")
const _hoisted_84 = /*#__PURE__*/_createVNode("sub", null, "i", -1)
const _hoisted_85 = { class: "rowRight" }
const _hoisted_86 = { class: "rowLeft" }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "rowTitle" }, "Temperature Difference", -1)
const _hoisted_88 = { class: "rowSubLine" }
const _hoisted_89 = { class: "subLabelsRow" }
const _hoisted_90 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Measured Value:", -1)
const _hoisted_91 = { class: "subLabel" }
const _hoisted_92 = { class: "subValsRow" }
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "subVal" }, "Warning Threshold:", -1)
const _hoisted_94 = { class: "subLabel" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("T")
const _hoisted_97 = /*#__PURE__*/_createVNode("sub", null, "max", -1)
const _hoisted_98 = /*#__PURE__*/_createTextVNode("-T")
const _hoisted_99 = /*#__PURE__*/_createVNode("sub", null, "min", -1)
const _hoisted_100 = { class: "rowRight" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_gauge = _resolveComponent("gauge")
  const _component_radar = _resolveComponent("radar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_gauge, {
              bgColor: "#D1F1E7",
              dataColor: _ctx.state.batterysoh.dataColor,
              dataShadowColor: _ctx.state.batterysoh.dataShadowColor,
              gaugeId: "gauge1",
              data: _ctx.getData(null, 'soh') === '-' ? 64 : _ctx.getData(null, 'soh'),
              total: 100
            }, null, 8, ["dataColor", "dataShadowColor", "data"]),
            _createVNode("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, [
                _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'soh')), 1),
                (_ctx.getData(null, 'soh') !== '-' )
                  ? (_openBlock(), _createBlock("span", _hoisted_9, "%"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_10,
              _createVNode("p", _hoisted_11, [
                _createVNode("img", {
                  src: require(`../../../../../assets/batteryFrame/${_ctx.state.batterysoh.class}.png`)
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_gauge, {
              bgColor: "#E8F3FF",
              dataColor: ["#E5F1FF","#5DAEFD"],
              dataShadowColor: "#5AA9FD",
              gaugeId: "gauge2",
              data: _ctx.getData(null, 'soh') === '-' ? 64 : _ctx.getData(null, 'soh'),
              total: 100
            }, null, 8, ["data"]),
            _createVNode("div", _hoisted_13, [
              _createVNode("p", _hoisted_14, [
                _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'kmRemain')), 1),
                (_ctx.getData(null, 'kmRemain') !== '-' )
                  ? (_openBlock(), _createBlock("span", _hoisted_15, "km"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'numberOfCycles')), 1),
              (_ctx.getData(null, 'numberOfCycles') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_20, "次"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_21
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("div", _hoisted_23, [
              _createVNode("b", null, _toDisplayString(_ctx.getData(null, 'annualAverageDecayRate')), 1),
              (_ctx.getData(null, 'annualAverageDecayRate') !== '-')
                ? (_openBlock(), _createBlock("span", _hoisted_24, "%"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_25
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          (_ctx.state.isShowRadar)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode(_component_radar, { renderData: _ctx.renderData }, null, 8, ["renderData"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_28, [
                _hoisted_29,
                _hoisted_30
              ]))
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("div", {
            class: ["batteryRow", {
                        rowError: _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '3',
                        rowWarn: _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '1' || _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '2',
                        rowGood: _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '0'
                    }]
          }, [
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode("span", _hoisted_37, _toDisplayString(_ctx.getData(_ctx.cellUnder, 'minMonoCellVoltage')), 1)
                ]),
                _createVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("span", _hoisted_40, [
                    (_ctx.getData(_ctx.cellUnder, 'alarm') !== '-')
                      ? (_openBlock(), _createBlock("span", _hoisted_41, [
                          _hoisted_42,
                          _hoisted_43
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.getData(_ctx.cellUnder, 'alarm')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode("span", {
                class: ["batteryScore", {
                            'error': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '3',
                            'warn': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '1' || _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '2',
                            'good': _ctx.getData(_ctx.cellUnder, 'cellUnderVoltage') === '0'
                        }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.cellUnder, 'cellUnderVoltage'))), 3)
            ])
          ], 2),
          _createVNode("div", {
            class: ["batteryRow", {
                        rowError: _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '3',
                        rowWarn: _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '1' || _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '2',
                        rowGood: _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '0'
                    }]
          }, [
            _createVNode("div", _hoisted_45, [
              _hoisted_46,
              _createVNode("div", _hoisted_47, [
                _createVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode("span", _hoisted_50, _toDisplayString(_ctx.getData(_ctx.cellOver, 'maxMonoCellVoltage')), 1)
                ]),
                _createVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode("span", _hoisted_53, [
                    (_ctx.getData(_ctx.cellOver, 'alarm') !== '-')
                      ? (_openBlock(), _createBlock("span", _hoisted_54, [
                          _hoisted_55,
                          _hoisted_56
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.getData(_ctx.cellOver, 'alarm')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_57, [
              _createVNode("span", {
                class: ["batteryScore", {
                            'error': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '3',
                            'warn': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '1' || _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '2',
                            'good': _ctx.getData(_ctx.cellOver, 'cellOverVoltage') === '0'
                        }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.cellOver, 'cellOverVoltage'))), 3)
            ])
          ], 2),
          _createVNode("div", {
            class: ["batteryRow", {
                        rowError: _ctx.getData(_ctx.difference, 'voltageDifference') === '3',
                        rowWarn: _ctx.getData(_ctx.difference, 'voltageDifference') === '1' || _ctx.getData(_ctx.difference, 'voltageDifference') === '2',
                        rowGood: _ctx.getData(_ctx.difference, 'voltageDifference') === '0'
                    }]
          }, [
            _createVNode("div", _hoisted_58, [
              _hoisted_59,
              _createVNode("div", _hoisted_60, [
                _createVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createVNode("span", _hoisted_63, _toDisplayString(_ctx.getData(_ctx.difference, 'voltageDifferenceValue')), 1)
                ]),
                _createVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode("span", _hoisted_66, [
                    (_ctx.getData(_ctx.difference, 'alarm') !== '-')
                      ? (_openBlock(), _createBlock("span", _hoisted_67, [
                          _hoisted_68,
                          _hoisted_69,
                          _hoisted_70,
                          _hoisted_71
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.getData(_ctx.difference, 'alarm')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_72, [
              _createVNode("span", {
                class: ["batteryScore", {
                            'error': _ctx.getData(_ctx.difference, 'voltageDifference') === '3',
                            'warn': _ctx.getData(_ctx.difference, 'voltageDifference') === '1' || _ctx.getData(_ctx.difference, 'voltageDifference') === '2',
                            'good': _ctx.getData(_ctx.difference, 'voltageDifference') === '0'
                        }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.difference, 'voltageDifference'))), 3)
            ])
          ], 2),
          _createVNode("div", {
            class: ["batteryRow", {
                        rowError: _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '3',
                        rowWarn: _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '1' || _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '2',
                        rowGood: _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '0'
                    }]
          }, [
            _createVNode("div", _hoisted_73, [
              _hoisted_74,
              _createVNode("div", _hoisted_75, [
                _createVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode("span", _hoisted_78, _toDisplayString(_ctx.getData(_ctx.overTemperature, 'highestTemperature')), 1)
                ]),
                _createVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createVNode("span", _hoisted_81, [
                    (_ctx.getData(_ctx.overTemperature, 'alarm') !== '-')
                      ? (_openBlock(), _createBlock("span", _hoisted_82, [
                          _hoisted_83,
                          _hoisted_84
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.getData(_ctx.overTemperature, 'alarm')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_85, [
              _createVNode("span", {
                class: ["batteryScore", {
                            'error': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '3',
                            'warn': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '1' || _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '2',
                            'good': _ctx.getData(_ctx.overTemperature, 'batteryOverTemperature') === '0'
                        }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.overTemperature, 'batteryOverTemperature'))), 3)
            ])
          ], 2),
          _createVNode("div", {
            class: ["batteryRow", {
                        rowError: _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '3',
                        rowWarn: _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '1' || _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '2',
                        rowGood: _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '0'
                    }]
          }, [
            _createVNode("div", _hoisted_86, [
              _hoisted_87,
              _createVNode("div", _hoisted_88, [
                _createVNode("div", _hoisted_89, [
                  _hoisted_90,
                  _createVNode("span", _hoisted_91, _toDisplayString(_ctx.getData(_ctx.temperatureDifference, 'temperatureDifferenceValue')), 1)
                ]),
                _createVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createVNode("span", _hoisted_94, [
                    (_ctx.getData(_ctx.temperatureDifference, 'alarm') !== '-')
                      ? (_openBlock(), _createBlock("span", _hoisted_95, [
                          _hoisted_96,
                          _hoisted_97,
                          _hoisted_98,
                          _hoisted_99
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(_ctx.getData(_ctx.temperatureDifference, 'alarm')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_100, [
              _createVNode("span", {
                class: ["batteryScore", {
                            'error': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '3',
                            'warn': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '1' || _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '2',
                            'good': _ctx.getData(_ctx.temperatureDifference, 'temperatureDifference') === '0'
                        }]
              }, _toDisplayString(_ctx.transScore(_ctx.getData(_ctx.temperatureDifference, 'temperatureDifference'))), 3)
            ])
          ], 2)
        ])
      ])
    ])
  ]))
})